"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlacementOption = exports.ActionBarOption = exports.DatepickerType = exports.DatepickerMode = void 0;
var DatepickerMode;
(function (DatepickerMode) {
    DatepickerMode["Year"] = "year";
    DatepickerMode["Month"] = "month";
    DatepickerMode["Date"] = "date";
    DatepickerMode["DateTime"] = "dateTime";
})(DatepickerMode = exports.DatepickerMode || (exports.DatepickerMode = {}));
var DatepickerType;
(function (DatepickerType) {
    DatepickerType["Range"] = "range";
    DatepickerType["Default"] = "default";
})(DatepickerType = exports.DatepickerType || (exports.DatepickerType = {}));
var ActionBarOption;
(function (ActionBarOption) {
    ActionBarOption["Today"] = "today";
    ActionBarOption["Accept"] = "accept";
    ActionBarOption["Clear"] = "clear";
    ActionBarOption["Cancel"] = "cancel";
})(ActionBarOption = exports.ActionBarOption || (exports.ActionBarOption = {}));
var PlacementOption;
(function (PlacementOption) {
    PlacementOption["Bottom"] = "bottom";
    PlacementOption["BottomEnd"] = "bottom-end";
    PlacementOption["BottomStart"] = "bottom-start";
    PlacementOption["Top"] = "top";
    PlacementOption["TopEnd"] = "top-end";
    PlacementOption["TopStart"] = "top-start";
})(PlacementOption = exports.PlacementOption || (exports.PlacementOption = {}));
//# sourceMappingURL=types.js.map